import './timePickerComponent.scss'
import React, {useCallback, useEffect, useState} from 'react';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {TimePicker} from '@mui/x-date-pickers/TimePicker';
import {FormHelperText} from "@mui/material";
import moment from "moment";
import FormControl from "@mui/material/FormControl";

interface TimePickerComponentProps {
    name: string;
    id?: string;
    label: string;
    value?: any;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    fullWidth?: boolean;
    size?: "small" | "medium" | undefined;
    variant?: "filled" | "standard" | "outlined" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    onUpdate?: Function;
    hasError?: boolean;
    errorMessage?: any;
    maxTime?:moment.Moment;
}

const convertStringToTImeFormat = ((value: any) => {
    try {
        const [hours, mins] = value?.split(":");
        const _moment = moment().set({"hour": hours, "minute": mins});
        return _moment.toDate();
    } catch (error) {
        console.error("Couldn't convert string to TIME format", error);
        return "";
    }
})

const TimePickerComponent = (props: TimePickerComponentProps) => {
        const [value, setValue] = useState<any | null>(props.value);
        const [open, setOpen] = useState<boolean>(false);
        const {
            name,
            id,
            label,
            disabled,
            readonly,
            required,
            hasError,
            errorMessage,
            fullWidth,
            maxTime
        } = props;
        let {placeholder, color, variant, onUpdate, size} = props;
        if (!placeholder) placeholder = label;
        if (!color) color = "secondary";
        if (!variant) variant = "outlined";
        if (!size) size = "medium";

        const handleChange = useCallback((newValue: Date | null) => {
            setValue(newValue);
            if (moment(newValue).format("HH:mm") !== 'Invalid date') {
                if (onUpdate) onUpdate(moment(newValue).format("HH:mm"));
            } else {
                if (onUpdate) onUpdate(null);
            }
        }, [onUpdate]);

        useEffect(() => {
            setValue((prevValue: any) => {
                if (prevValue) {
                    convertStringToTImeFormat(prevValue)
                }
            });
        }, []);

        useEffect(() => {
            if (props.value === "") {
                setValue(props.value);
            } else if (!!props.value) {
                setValue((oldValue: any) => {
                        let tempValue = oldValue;
                        if (oldValue !== convertStringToTImeFormat(props.value)) {
                            tempValue = convertStringToTImeFormat(props.value);
                        }
                        return tempValue
                    }
                )
            }
        }, [props.value])

        return (
            <FormControl variant={variant} size={size} className="input-component-wrapper"
                         fullWidth={fullWidth} error={hasError}
                         sx={{
                             "& .MuiOutlinedInput-root": {
                                 background: "#FAFAFA"
                             }
                         }
                         }>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TimePicker
                        label={label}
                        timeSteps={{minutes:1}}
                        readOnly={readonly}
                        value={value || null}
                        disabled={disabled}
                        ampm={false}
                        onChange={handleChange}
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        maxTime={maxTime?.toDate()}
                        //new version code
                        slotProps={{
                            textField: {
                                required: required,
                                placeholder: placeholder,
                                error: hasError,
                                name: name,
                                id: id,
                                color: color,
                                onClick: () => setOpen(true)
                            },
                        }}
                        //old version code "@mui/x-date-pickers": "^6.9.2"
                        // renderInput={(params) => <TextField
                        //     required={required} id={id} name={name}
                        //     color={color}
                        //     size={size}
                        //     onClick={(e) => setOpen(true)}
                        //     placeholder={placeholder} {...params} />}
                    />
                </LocalizationProvider>
                <FormHelperText>
                    {hasError && errorMessage}
                </FormHelperText>
            </FormControl>
        )
    }

;

export default TimePickerComponent;
